import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaPhone, FaEnvelope } from 'react-icons/fa';
import './Navbar.css';
import beReliableLogo from "../../assets/logo/bereliable-logo.png";

const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });


const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="bereliable-header">
      {/* TOP BAR - 30% height */}
      <div className="header-top-bar">
        <div className="header-top-container">
          <div className="header-contact-info">
            <a href="tel:+917041711159" className="header-contact-item">
              <FaPhone className="header-contact-icon" />
              <span>+91 70417 11159</span>
            </a>
            <a href="mailto:insurance@bereliable.in" className="header-contact-item">
              <FaEnvelope className="header-contact-icon" />
              <span>insurance@bereliable.in</span>
            </a>
          </div>
        </div>
      </div>

      {/* MAIN NAVBAR - 70% height */}
      <nav className="header-main-navbar">
        <div className="header-nav-container">
          <Link
            to="/"
            className="header-logo"
            onClick={() => {
              closeMenu();
              scrollToTop();
            }}
          >
  <img src={beReliableLogo} alt="BeReliable Logo" className="main-logo" />
</Link>

          <div className={`header-nav-menu ${isMenuOpen ? 'active' : ''}`}>
            <Link
              to="/"
              className={`header-nav-link ${isActive('/') ? 'active' : ''}`}
              onClick={() => {
                closeMenu();
                scrollToTop();
              }}
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`header-nav-link ${isActive('/about') ? 'active' : ''}`}
              onClick={() => {
                closeMenu();
                scrollToTop();
              }}
            >
              About Us
            </Link>
            <Link
              to="/products"
              className={`header-nav-link ${isActive('/products') ? 'active' : ''}`}
              onClick={() => {
                closeMenu();
                scrollToTop();
              }}
            >
              Products
            </Link>
            <Link
              to="/claims"
              className={`header-nav-link ${isActive('/claims') ? 'active' : ''}`}
              onClick={() => {
                closeMenu();
                scrollToTop();
              }}
            >
              Claims
            </Link>
            <Link
              to="/contact"
              className={`header-nav-link ${isActive('/contact') ? 'active' : ''}`}
              onClick={() => {
                closeMenu();
                scrollToTop();
              }}
            >
              Contact
            </Link>
          </div>

          <div className="header-nav-right">
            <Link
              to="/inquiry"
              className="header-quote-btn"
              onClick={() => {
                closeMenu();
                scrollToTop();
              }}
            >
              Get Quote
            </Link>
            <button className="header-menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
              {isMenuOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
